import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import noop from 'lodash.noop'
import SizePickerSelect from '../../containers/SizePickerSelect'

import * as Styled from './StickySelectSizePicker.styles'

const StickySelectSizePicker = ({
  type,
  value,
  partNumber,
  combinations,
  selectPartNumber,
  sizeInfo = noop,
  hasSizeChange,
  isTuTestVariant
}) => {
  const [portalTarget, setPortalTarget] = useState(null)

  useEffect(() => {
    if (typeof document !== 'undefined') {
      const target = document.getElementById('stickySizeSelector-portal')
      setPortalTarget(target)
    }
  }, [])

  const showSelector = combinations?.length > 1

  const sizePickerSelect = (
    <SizePickerSelect
      type={type}
      partNumber={partNumber}
      selectPartNumber={selectPartNumber}
      combinations={combinations}
    />
  )

  if (!portalTarget && isTuTestVariant) {
    return null
  }

  return (
    <Styled.StickySelectSizePickerWrapperABTest isTuTestVariant={isTuTestVariant}>
      <Styled.SizePickerHeader>
        <p data-test='select-size-picker-header'>
          <strong>
            {type}: {value}
          </strong>
        </p>
        {sizeInfo()}
      </Styled.SizePickerHeader>

      {hasSizeChange && showSelector && (
        <Styled.SizeAlert kind='info' isCloseable={false} data-test='select-size-alert'>
          Please check the sizes available in this colour:
        </Styled.SizeAlert>
      )}

      {showSelector && (isTuTestVariant ? ReactDOM.createPortal(sizePickerSelect, portalTarget) : sizePickerSelect)}
    </Styled.StickySelectSizePickerWrapperABTest>
  )
}

StickySelectSizePicker.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  partNumber: PropTypes.string.isRequired,
  combinations: PropTypes.array.isRequired,
  selectPartNumber: PropTypes.func.isRequired,
  sizeInfo: PropTypes.func,
  isTuTestVariant: PropTypes.bool
}

StickySelectSizePicker.defaultProps = {
  sizeInfo: noop,
  isTuTestVariant: false
}

export default StickySelectSizePicker
